import React, { useEffect } from "react";  

import {  
    ContentBody,
    ContentAnimation
} from "./styled";

import { 
    Animation
} from "ui/styled";

import ContainerLandpage from "containers/Landpage";

// 16/10/2026: endereço que não existe. O servidor entrega a página inicial (o site é de uma página só) e é aqui
// que o site descobre que o endereço não existe. Por isso a página avisa ao Google para não guardar este
// endereço (noindex) e muda o título; ao sair dela, tudo volta como estava.
export default function NotFound(){ 
    useEffect(() => {
        const tituloAntes = document.title;
        let marca = document.querySelector('meta[name="robots"]');
        const criada = !marca;
        const conteudoAntes = marca ? marca.getAttribute('content') : null;
        if (criada) {
            marca = document.createElement('meta');
            marca.setAttribute('name', 'robots');
            document.head.appendChild(marca);
        }
        marca.setAttribute('content', 'noindex');
        document.title = 'Página não encontrada | JoinKids';
        return () => {
            document.title = tituloAntes;
            if (criada) marca.remove();
            else marca.setAttribute('content', conteudoAntes);
        };
    }, []);
 
    return ( 
        <ContainerLandpage> 
            <ContentBody>
                <ContentAnimation>
                    <Animation animationData={require('assets/lotties/404.json')}  />
                </ContentAnimation>
            </ContentBody>  
        </ContainerLandpage>
    );
}
